import { useEffect } from 'react';

const NR_LOADER_SRC =
  'https://js-agent.newrelic.com/nr-loader-spa-1.260.1.min.js';

const useNewRelic = () => {
  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      !window.manifest ||
      !window.manifest.newrelicLicenseKey
    ) {
      return undefined;
    }

    const { manifest } = window;

    window.NREUM = {
      init: {
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ['bam.nr-data.net'] },
        session_replay: {
          enabled: true,
          sampling_rate: 20.0,
          error_sampling_rate: 100.0,
          mask_all_inputs: true,
          mask_text_selector: '*',
          collect_fonts: false,
          inline_images: false,
          inline_stylesheet: true,
        },
      },
      info: {
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: manifest.newrelicLicenseKey,
        applicationID: manifest.newrelicApplicationId,
        sa: 1,
      },
      loader_config: {
        applicationID: manifest.newrelicApplicationId,
        agentID: manifest.newrelicApplicationId,
        licenseKey: manifest.newrelicLicenseKey,
        accountID: manifest.newrelicAccountId,
        trustKey: manifest.newrelicTrustKey,
      },
    };

    const script = document.createElement('script');
    script.src = NR_LOADER_SRC;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
};

export default useNewRelic;
